export default __webpack_public_path__ + "static/media/fixture1_boxlose.e38a7fe5.png";